import { autoinject, bindable, computedFrom } from "aurelia-framework";
import { UserClaimsService } from "../../../services/authentication/user-claims.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { Claims } from "../../../constants/authentication/claims";
import { Messages } from "../../../configuration/event-messages.constants";

@autoinject
export class CompCiiRating {

    isCustomer: boolean;

    @bindable
    rating: string;

    @bindable
    ratingYear: number;

    @bindable
    showRatingColor: boolean;

    @bindable
    showLabel: boolean;

    @bindable
    showInfoTooltip: boolean;

    @bindable
    showStatus: boolean = true;

    @bindable
    maskData: boolean = false;

    @bindable
    lockedFeature: boolean = false;

    @bindable
    unlockFeatureKey: string;

    constructor(userClaimsService: UserClaimsService,
        private eventAggregator: EventAggregator) {
        this.isCustomer = !userClaimsService.hasPermission(Claims.RightShipUser);
    }

    @computedFrom('ratingYear')
    get ciiRatingUiStatus() {
        const today = new Date().getFullYear();
        const yearsForExpiry = 2;

        if (this.ratingYear) {

            if (today - this.ratingYear < yearsForExpiry) {
                return CiiRatingUiStatus.Certified;
            } else {
                return CiiRatingUiStatus.NotCertified;
            }
        } else {
            return CiiRatingUiStatus.NotAvailable;
        }
    }

    @computedFrom('ciiRatingUiStatus', 'ratingYear')
    get status() {
        if (this.ciiRatingUiStatus == CiiRatingUiStatus.Certified) {
            return `Certified (${this.ratingYear})`
        }
        else if (this.ciiRatingUiStatus == CiiRatingUiStatus.NotCertified) {
            return `Last Updated (${this.ratingYear})`
        }
        else if (this.ciiRatingUiStatus == CiiRatingUiStatus.NotAvailable) {
            return `Not Available`
        }
    }

    unlockFeature() {
        if (this.lockedFeature === true) {
            this.eventAggregator.publish(Messages.unlockFeature, this.unlockFeatureKey);
        }
    }
}

export enum CiiRatingUiStatus {
    Certified,
    NotCertified,
    NotAvailable
}